var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLemonroyal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 65,
    viewBox: "0 0 48 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.5301H12.1872V58.4932C12.1872 61.7765 9.45666 64.4423 6.09358 64.4423C2.73051 64.4423 0 61.7765 0 58.4932V37.5301Z",
    fill: "url(#paint0_linear_1_81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0965 11.561C37.9574 12.2749 36.6893 18.1616 30.7465 21.1446C30.259 20.5979 26.2924 15.9916 27.5546 9.58363C27.6939 8.86973 28.962 2.98302 34.9046 0C35.3922 0.546744 39.3589 5.15302 38.0965 11.561Z",
    fill: "url(#paint1_linear_1_81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7557 24.5158C41.2621 24.6574 37.162 25.7735 33.3959 23.1645C33.5845 22.697 35.2152 18.8585 39.6402 17.5752C40.1334 17.4335 44.2335 16.3174 47.9999 18.9264C47.8114 19.3939 46.1806 23.2325 41.7557 24.5158Z",
    fill: "url(#paint2_linear_1_81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8611 55.9438C29.2778 55.9438 37.7221 47.6998 37.7221 37.5301C37.7221 27.3604 29.2778 19.1163 18.8611 19.1163C8.44439 19.1163 0 27.3604 0 37.5301C0 47.6998 8.44439 55.9438 18.8611 55.9438Z",
    fill: "url(#paint3_linear_1_81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.04472 50.9663C11.3364 50.9663 13.1941 49.1527 13.1941 46.9154C13.1941 44.6779 11.3364 42.8642 9.04472 42.8642C6.75303 42.8642 4.89526 44.6779 4.89526 46.9154C4.89526 49.1527 6.75303 50.9663 9.04472 50.9663Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6286 37.5301C31.6286 44.4139 25.9123 49.9947 18.8611 49.9947C14.7378 49.9947 11.07 48.0851 8.73705 45.1219C8.20023 44.4452 7.73594 43.7113 7.35293 42.9352V42.9295C6.54334 41.2949 6.09357 39.4649 6.09357 37.5301C6.09357 30.6461 11.81 25.0653 18.8611 25.0653C22.0994 25.0653 25.0563 26.2409 27.3051 28.1815C29.9572 30.4648 31.6286 33.8075 31.6286 37.5301Z",
    fill: "url(#paint4_linear_1_81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3051 28.1815C26.333 28.0143 19.9695 27.0087 14.5085 31.2976C7.95648 36.4449 8.67318 44.5357 8.73705 45.1219L7.35293 42.9352V42.9295C6.54334 41.2949 6.09357 39.4649 6.09357 37.5301C6.09357 30.6461 11.81 25.0653 18.8611 25.0653C22.0994 25.0653 25.0563 26.2409 27.3051 28.1815Z",
    fill: "url(#paint5_linear_1_81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.3254 31.4195C29.617 31.4195 31.4748 29.6058 31.4748 27.3685C31.4748 25.1311 29.617 23.3174 27.3254 23.3174C25.0337 23.3174 23.1759 25.1311 23.1759 27.3685C23.1759 29.6058 25.0337 31.4195 27.3254 31.4195Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_81",
    x1: -4.11751,
    y1: 38.5979,
    x2: 16.6764,
    y2: 61.2297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#00D7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_81",
    x1: 36.759,
    y1: -0.0742263,
    x2: 29.7355,
    y2: 19.8634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#448BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB51BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_81",
    x1: 48.636,
    y1: 20.0066,
    x2: 33.8617,
    y2: 22.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3C3ACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_81",
    x1: 8.61517,
    y1: 26.9011,
    x2: 29.4091,
    y2: 49.5327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#00D7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_81",
    x1: 9.94415,
    y1: 29.7905,
    x2: 29.5207,
    y2: 47.6143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#448BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00D7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#448BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_81",
    x1: 9.70621,
    y1: 29.4336,
    x2: 19.456,
    y2: 38.3147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB51BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonroyal);
export default __webpack_public_path__ + "static/media/Lemonroyal.536000971e9b14caed3979e87d2492d1.svg";
export { ForwardRef as ReactComponent };